module.exports = __webpack_public_path__ + "img/desktop.bed96d37.png";